import Vue from 'vue';
import Router from 'vue-router';

import AppRoutes from '@/main/routes';
import store from './store';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes: AppRoutes,
  scrollBehavior: (to) => {
    const isRenewal = store.getters['App/Checkout/isRenewal'];
    const customTemplateGuid = store.getters['App/Checkout/customTemplateGuid'];
    const { order_id, contract_id } = to.params;

    if (
      !isRenewal &&
      !order_id &&
      !contract_id &&
      customTemplateGuid
    ) {
      return {
        selector: '.copy-step.checkout',
        offset: { x: 0, y: 120 },
      };
    }

    return { x: 0, y: 0 };
  },
});
